import React, { useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCloudUploadAlt, faTimes, faFilePdf, faExchangeAlt } from "@fortawesome/free-solid-svg-icons";

const FileUploadArea = ({
  label = "Comprobante de pago",
  accept = "image/png, image/jpeg, image/gif, image/webp, application/pdf",
  onChange,
  preview,
  fileName,
  onRemove,
  error,
  required = false,
}) => {
  const inputRef = useRef();
  const isPdf = fileName && fileName.toLowerCase().endsWith(".pdf");

  return (
    <div className="mb-2">
      {label && (
        <label className="mb-2 font-weight-semi-bold d-block">
          {label}
          {required && <span className="text-danger ml-1">*</span>}
        </label>
      )}

      {!preview ? (
        <div
          onClick={() => inputRef.current.click()}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") inputRef.current.click(); }}
          className="rounded text-center"
          style={{
            border: `2px dashed ${error ? "#e63757" : "#d8e2ef"}`,
            backgroundColor: "#f9fafd",
            cursor: "pointer",
            padding: "24px 16px",
            transition: "border-color 0.2s, background-color 0.2s",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.borderColor = "#2c7be5";
            e.currentTarget.style.backgroundColor = "#eef2ff";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.borderColor = error ? "#e63757" : "#d8e2ef";
            e.currentTarget.style.backgroundColor = "#f9fafd";
          }}
        >
          <FontAwesomeIcon
            icon={faCloudUploadAlt}
            size="2x"
            className="text-400 mb-2 d-block mx-auto"
          />
          <p className="mb-0 fs--1 text-700 font-weight-semi-bold">
            Haz clic o arrastra un archivo aquí
          </p>
          <p className="mb-0 fs--2 text-500 mt-1">PNG, JPG, GIF, PDF · máx. 10 MB</p>
          <input
            ref={inputRef}
            type="file"
            accept={accept}
            onChange={onChange}
            className="d-none"
          />
        </div>
      ) : (
        <div
          className="rounded border"
          style={{ backgroundColor: "#f9fafd", overflow: "hidden" }}
        >
          {isPdf ? (
            <div className="d-flex align-items-center p-3">
              <div
                className="d-flex align-items-center justify-content-center rounded mr-3 flex-shrink-0"
                style={{ width: 44, height: 44, backgroundColor: "#fde8e8" }}
              >
                <FontAwesomeIcon icon={faFilePdf} className="text-danger" size="lg" />
              </div>
              <span className="fs--1 text-700 text-truncate flex-grow-1">{fileName}</span>
            </div>
          ) : (
            <div
              className="d-flex align-items-center justify-content-center"
              style={{ backgroundColor: "#f1f3f5", minHeight: 160, maxHeight: 200, overflow: "hidden" }}
            >
              <img
                src={preview}
                alt="preview"
                style={{
                  maxHeight: 200,
                  maxWidth: "100%",
                  objectFit: "contain",
                  display: "block",
                }}
              />
            </div>
          )}

          <div
            className="d-flex align-items-center justify-content-between px-3 py-2"
            style={{ borderTop: "1px solid #e2e8f0" }}
          >
            {fileName && (
              <span
                className="fs--2 text-600 text-truncate mr-2"
                style={{ maxWidth: "60%" }}
                title={fileName}
              >
                {fileName}
              </span>
            )}
            <div className="d-flex ml-auto" style={{ gap: 6 }}>
              <button
                type="button"
                onClick={() => inputRef.current.click()}
                className="btn btn-sm btn-falcon-default d-flex align-items-center"
                style={{ fontSize: "0.72rem", gap: 4 }}
              >
                <FontAwesomeIcon icon={faExchangeAlt} className="mr-1" />
                Cambiar
              </button>
              <button
                type="button"
                onClick={onRemove}
                className="btn btn-sm btn-danger d-flex align-items-center justify-content-center"
                style={{ width: 30, height: 30, padding: 0, borderRadius: 6 }}
                title="Quitar archivo"
              >
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>
          </div>

          <input
            ref={inputRef}
            type="file"
            accept={accept}
            onChange={onChange}
            className="d-none"
          />
        </div>
      )}

      {error && (
        <small className="text-danger d-block mt-1">{error}</small>
      )}
    </div>
  );
};

export default FileUploadArea;
